import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'right',
    standalone: false
})
export class RightPipe implements PipeTransform {
    transform(value: string, count: number = 4): string {
        if (!value || typeof value !== 'string' || count < 0) {
            return '';
        }

        return value.slice(-count);
    }
}
